import PropTypes from 'prop-types';

function TikTokIcon({ className = "", fill = "#000000", size = "24" }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 29.34 29.34" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill={fill} d="M22.57,11.5c-.94,0-1.84-.38-2.5-1.04-.66-.66-1.04-1.56-1.04-2.5v-.3h-3.03v10.1c0,.73-.3,1.4-.78,1.88-.49,.48-1.15,.78-1.88,.78s-1.4-.3-1.88-.78c-.48-.49-.78-1.15-.78-1.88s.3-1.4,.78-1.88c.49-.48,1.15-.78,1.88-.78,.13,0,.26,.01,.38,.03v-3.07c-.13-.01-.25-.02-.38-.02-1.53,0-2.92,.62-3.93,1.62-1,1-1.62,2.39-1.62,3.93s.62,2.92,1.62,3.93c1,1,2.39,1.62,3.93,1.62s2.92-.62,3.93-1.62c1-1,1.62-2.39,1.62-3.93V10.7c1.01,.94,2.35,1.53,3.82,1.53h.3v-3.03h-.3c-.06,0-.12,0-.18,0v2.3Z"/>
        <circle fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth="2px" cx="14.67" cy="14.67" r="13.67"/>
      </g>
    </svg>
  )
}

TikTokIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TikTokIcon